export class FixLightboxPlaceholders {
    constructor(
        lightboxWrapperSelector = '.glightbox-container',
        placeholderSelector = '.uc-embedding-container'
    ) {
        this.lightboxWrapperSelector = lightboxWrapperSelector;
        this.placeholderSelector = placeholderSelector;

        this.onChildChange = this.onChildChange.bind(this);
        this.fixPlaceholder = this.fixPlaceholder.bind(this);
        this.init = this.init.bind(this);

        this.observer = new MutationObserver(this.onChildChange);

        this.fixPlaceholders();
    }

    init(element) {
        if (element.querySelector(this.placeholderSelector)) {
            element.classList.add('contains-placeholder');
        }
    }

    fixPlaceholder(element) {
        this.observer.observe(element, { childList: true });
    }

    fixPlaceholders() {
        document
            .querySelectorAll(this.lightboxWrapperSelector)
            .forEach((element) => {
                this.fixPlaceholder(element);
                this.init(element);
            });
    }

    onChildChange(mutations) {
        const lastChange = mutations.shift();
        const element = lastChange.target;

        if (element.querySelector(this.placeholderSelector)) {
            element.classList.add('contains-placeholder');
        } else if (lastChange.removedNodes && lastChange.removedNodes.length) {
            const stillContainsPlaceholder = lastChange.target.querySelector(
                this.placeholderSelector
            );
            if (!stillContainsPlaceholder) {
                lastChange.target.classList.remove('contains-placeholder');
            }
        }
    }
}
